import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { RightHeaderSideComponent } from './right-header-side.component';
import { CurrentUserBoxModule } from '@app/theme/current-user-box/current-user-box.module';
import { MenuModule } from '@app/theme/menu/menu.module';
import { ReturnToWebsiteBoxComponent } from './return-to-website-box/return-to-website-box.component';
import { MaterialModule } from '@app/material/material.module';

@NgModule({
  declarations: [RightHeaderSideComponent, ReturnToWebsiteBoxComponent],
  imports: [CommonModule, RouterModule, CurrentUserBoxModule, MenuModule, MaterialModule],
  exports: [RightHeaderSideComponent],
})
export class RightHeaderSideModule {}
